@if (showFeedback$() && !isMobileView$() && question().feedbackMessage) {
  <span class="feedback-message">{{ question().feedbackMessage }}</span>
}
<div #rankSortContainer class="rank-sort" [ngClass]="isMobileView$() ? 'mobile' : 'web'" cdkDropListGroup>
  <div
    class="rank-sort__container"
    cdkTrapFocus
    cdkDropList
    id="options"
    [cdkDropListData]="options$()"
    [cdkDropListConnectedTo]="rankIds"
    (cdkDropListDropped)="onDropOption($event)"
  >
    @if (showFeedback$() && isMobileView$() && question().feedbackMessage) {
      <span class="feedback-message">{{ question().feedbackMessage }}</span>
    }

    @for (option of options$(); track option; let index = $index) {
      @if (!option && !isMobileView$()) {
        <div class="rank-sort__container-placeholder"></div>
      } @else if (option) {
        <div cdkDrag class="rank-sort__container-option" [cdkDragDisabled]="isOtherExclusiveSelected$()" (click)="moveItem(option, index)">
          <span cdkDragHandle class="rank-sort__container-option-content">
            @if (!isOtherExclusiveSelected$()) {
              <fa-icon [icon]="faGripDotsVertical" [title]="'Move option'"></fa-icon>
            }
            <span class="survey-viewer__html-content fs__xl" [innerHTML]="option.text | content: question().id"></span>
          </span>
        </div>
      }
    }

    @if (isMobileView$()) {
      <ng-container *ngTemplateOutlet="useNone"></ng-container>
    }
  </div>
  @if (isMobileView$()) {
    <span class="rank-sort__divider"></span>
  }

  <div class="rank-sort__container">
    @for (rank of ranks$(); track rank; let index = $index) {
      <div
        class="rank-sort__container-rank"
        cdkDropList
        [class]="!rank ? 'rank-empty' : 'rank-selected'"
        [cdkDropListData]="[rank]"
        [id]="'rank-' + index"
        [cdkDropListConnectedTo]="['options']"
        (cdkDropListDropped)="onDropRank($event, index)"
      >
        @if (rank) {
          <div cdkDrag class="rank-sort__container-rank-option" [ngClass]="rank.value === 'OTHER' ? 'other' : ''">
            <span cdkDragHandle class="rank-sort__container-option-content">
              <fa-icon [icon]="faGripDotsVertical" [title]="'Move rank'"></fa-icon>
              <span class="survey-viewer__html-content fs__xl" [innerHTML]="rank.text | content: question().id"></span>
            </span>
            @if (rank.value === 'OTHER') {
              <mat-form-field appearance="outline" class="other-input">
                <input
                  matInput
                  surveyAutoFocus
                  placeholder="Please specify"
                  [formControl]="questionCtrl().get('otherText') | toFormControl"
                  [required]="questionCtrl().get('value')?.value.includes('OTHER')"
                  autocomplete="off"
                />
              </mat-form-field>
            }
          </div>
        } @else {
          <span class="rank-sort__container-rank-content">
            @if (isNumeric$()) {
              <span class="rank-sort__container-rank-content-numeric fs__xs">{{ index + 1 }}</span>
            } @else {
              <span class="survey-viewer__html-content fs__xl" [innerHTML]="question().ranks[index]?.text | content: question().id"></span>
            }
          </span>
        }
      </div>
    }
  </div>

  @if (isMobileView$()) {
    <span class="rank-sort__label fs__lg">Tap or drag to add your ranking below.</span>
  }
</div>
@if (!isMobileView$()) {
  <ng-container *ngTemplateOutlet="useNone"></ng-container>
}

<ng-template #useNone>
  @if (question().useNoneInd) {
    <div class="rank-sort__none-option" [ngClass]="!isMobileView$() ? 'rank-sort__none-option-web' : ''">
      <mat-checkbox color="accent" [checked]="questionCtrl().get('value').value | checked: noneOption.value" (change)="onCheckedNone($event, noneOption)">
        <span class="label survey-viewer__html-content fs__lg fw__400" [innerHTML]="question().noneLabel | content: question().id"></span>
      </mat-checkbox>
    </div>
  }
</ng-template>
